(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ua-pack-picker"] && !Shopify.designMode) return;
  try {
    function initUaSwatches(){
document.querySelectorAll('.ua-pack-choice:not(.ua-visual-ready)').forEach(function(choice){
const select=choice.querySelector('select'),details=choice.querySelector('details');
function update(){const button=Array.from(choice.querySelectorAll('[data-colour]')).find(b=>b.dataset.colour===select.value);choice.querySelectorAll('[data-colour]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));if(button){choice.querySelector('.ua-selected-name').textContent=button.dataset.colour;choice.querySelector('.ua-selected-swatch').style.setProperty('--ua-shade',button.dataset.shade);}}
choice.querySelectorAll('[data-colour]').forEach(function(button){button.addEventListener('click',function(){select.value=button.dataset.colour;select.dispatchEvent(new Event('change',{bubbles:true}));details.open=false;details.querySelector('summary').focus();});});
select.addEventListener('change',update);
select.addEventListener('invalid',function(event){event.preventDefault();details.open=true;details.querySelector('summary').focus();});
choice.classList.add('ua-visual-ready');update();
});}
initUaSwatches();
document.addEventListener('shopify:section:load',initUaSwatches);
const uaSwatchObserver=new MutationObserver(initUaSwatches);uaSwatchObserver.observe(document.body,{childList:true,subtree:true});
  } catch(e) { console.error(e); }
})();

})();
